import { ingredientTypeMap } from 'constants/ingredientType';

/**
 * get ingredient type by object details
 * @param {Object} ingredient ingredient object
 * @returns ingredient type
 */
export const getIngredientType = ingredient => {
    if (!ingredient) {
        return null;
    }
    if (!ingredient.supc && ingredient.batchRecipeId === -1) {
        return ingredientTypeMap.CUSTOM_INGREDIENTS;
    } else if (!ingredient.supc && ingredient.batchRecipeId > 0) {
        return ingredientTypeMap.BATCH_RECIPES;
    } else if (ingredient.supc) {
        return ingredientTypeMap.SYSCO_PRODUCTS;
    } else {
        return null;
    }
}

/**
 * Removes opcoId prefix from the supc
 * @param {String} supc supc with opcoId eg: 067_1234567
 * @returns {String} supc without opcoId eg: 1234567
 */
export const getAbsoluteSupc = supc => {
    if (!supc) {
        return '';
    }

    const breakIndex = supc.indexOf('_');
    if (breakIndex === -1) {
        return supc;
    }

    return supc.substring(breakIndex + 1);
}
